export {
  registerCustomLockScriptInfos,
  injectCapacity,
  setupInputCell,
  transfer,
  payFee,
  payFeeByFeeRate,
  prepareSigningEntries,
} from "@ckb-lumos/common-scripts/lib/common";
